import React from 'react'
import "../../../assets/scss/style/_footer.scss"
import { faHome } from "@fortawesome/free-solid-svg-icons";

interface Props { }

function Footer(props: Props) {
    const { } = props

    return (
        <div className="footerConteiner">
        <div className="footer">
            <div></div>
            <div >
                <h4>ABOUT SKILLERS</h4>
            </div>
            <div>
                <h4>Top Categories</h4>
                <ul>
                    <li>Digital Marketing</li>
                    <li>HR</li>
                    <li>Healthcare</li>
                    <li>Type Something</li>
                    <li>Product Management</li>
                </ul>
            </div>
            <div className="contactUs">
                <h4>Contact US</h4>
                <ul>
                    <li>Info@skillers.co</li>
                    <li>Armenia, Yerevan</li>
                    <li>Hakob Hakobyan 3 str.</li>

                </ul>
            </div>
            <div></div>
            <div className="logoBlock">
                <img src="/Logo.png" ></img>
                <h5>2020 Skillers </h5>
            </div>
            <div className="logoBlock">
                <h5 className="allRight">All Right reserved</h5>
            </div>
            <div className="logoBlock">
                <a href="#top">All Categories</a>
            </div>
            <div className="logoBlock">
                <div className="socBlock">
                   
                    <img src="/linkedin.png"/>
                    <img src="/facebook.png"/>
                    <img src="/pinterest.png"/>
                    <img src="/twitter.png"/>
                </div>
               
          
            </div>
            <div className="toTop"><a  href="#top">  <img  src="/top.png"/></a></div>

        </div>
        </div>
    )
}

export default Footer
